import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ShareModal } from '@/components/ShareModal';

interface ShareData {
  kind: 'book' | 'review';
  book_id?: string;
  review_id?: string;
  book?: {
    id: string;
    title: string;
    authors: string[];
    cover_url?: string;
  };
  review?: any;
}

interface ShareButtonProps {
  shareData: ShareData;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
  children?: React.ReactNode;
}

export function ShareButton({ 
  shareData, 
  variant = 'outline', 
  size = 'sm', 
  className,
  children 
}: ShareButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => setIsOpen(true)}
      >
        {children || (
          <>
            <Share2 className="w-4 h-4 mr-2" />
            Share
          </>
        )}
      </Button>
      
      <ShareModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        shareData={shareData}
        mode="share"
      />
    </>
  );
}